import React, { FC } from "react";
import { useTranslations } from "next-intl";
import dayjs from "dayjs";

import { renderTransportationIcon } from "@/utils/iconRenderer";
import { Theme, TransportationMode } from "@/enums";
import { useTheme } from "@/context/Theme.context";
import { isGroundGeo } from "@/utils/customUtils";

export const displayTransportationMode = (mode: TransportationMode, t: any) => {
  switch (mode) {
    case TransportationMode.AIR:
      return t("air");
    case TransportationMode.SEA:
      return t("sea");
    case TransportationMode.GROUND:
      return t("ground");
    default:
      return "";
  }
};

type TProps = {
  estimatedArrival?: string;
  mode: TransportationMode;
  label?: string;
  showDate?: boolean;
  countryId: number;
};

const TransportationWrapper: FC<TProps> = ({
  label = "estimated_arrival",
  estimatedArrival,
  mode,
  showDate = true,
  countryId,
}) => {
  const theme = useTheme();
  const t = useTranslations();

  // custom transportation type on GEORGIA
  const groundGeo = isGroundGeo(theme as Theme, countryId);

  return (
    <div className="flex flex-row items-center gap-3">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#f9f9f9]">
        {groundGeo
          ? renderTransportationIcon[TransportationMode.GROUND]
          : renderTransportationIcon[mode]}
      </div>

      <div>
        {showDate ? (
          <p className="text-sm font-medium">
            {label ? t(label) : ""}{" "}
            {estimatedArrival
              ? dayjs(estimatedArrival).format("YYYY-MM-DD")
              : ""}
          </p>
        ) : null}

        <p className="text-xs text-[#9a9a9a]">
          {groundGeo
            ? displayTransportationMode(TransportationMode.GROUND, t)
            : displayTransportationMode(mode, t)}
        </p>
      </div>
    </div>
  );
};

export { TransportationWrapper };
